export const PRIVACY_PT = [
  {
    title: "1. Responsável pelo Tratamento",
    paras: [
      "A plataforma PASS Algarve é operada por GORGEOUS BLOSSOM TOURISM LDA, inscrita no NIF/NIPC 517 954 095, com sede em Lagos, no Algarve, Portugal (doravante \"PASS Algarve\").",
      "O PASS Algarve é o responsável pelo tratamento dos dados pessoais recolhidos através do website passalgarve.com e dos serviços associados.",
      "Para qualquer questão relacionada com o tratamento de dados pessoais, o utilizador pode contactar-nos através do email info@passalgarve.com.",
    ],
  },
  {
    title: "2. Dados Pessoais Recolhidos",
    paras: ["No âmbito da utilização da plataforma, poderão ser recolhidos os seguintes dados pessoais:"],
    list: [
      "dados de identificação: nome e apelido;",
      "dados de contacto: endereço de email;",
      "dados de conta: credenciais de acesso (a palavra-passe é armazenada de forma cifrada);",
      "dados de compra: passaportes adquiridos, quantidade, nomes dos titulares indicados, histórico de compras e utilizações;",
      "dados de pagamento: processados diretamente pela Stripe — o PASS Algarve não armazena números de cartão;",
      "dados de utilização do PASS: validações de QR Code, data, hora e atração visitada;",
      "dados técnicos: endereço IP, tipo de dispositivo e navegador, quando necessários à segurança e ao funcionamento da plataforma.",
    ],
  },
  {
    title: "3. Finalidades do Tratamento",
    paras: ["Os dados pessoais são tratados para as seguintes finalidades:"],
    list: [
      "criação e gestão da conta de cliente;",
      "processamento de compras e emissão dos passaportes digitais e QR Codes;",
      "envio de comunicações necessárias à execução do serviço (confirmações de compra, QR Codes, alterações e cancelamentos);",
      "validação dos passaportes junto das atrações parceiras;",
      "gestão de reservas, quando aplicável;",
      "apoio ao cliente;",
      "prevenção e deteção de fraude e utilização indevida;",
      "cumprimento de obrigações legais, fiscais e contabilísticas.",
    ],
  },
  {
    title: "4. Fundamentos de Licitude",
    paras: ["O tratamento dos dados assenta nos seguintes fundamentos previstos no RGPD:"],
    list: [
      "execução de contrato (art. 6.º, n.º 1, al. b): gestão da conta, compras, emissão e validação dos passaportes;",
      "cumprimento de obrigações legais (art. 6.º, n.º 1, al. c): faturação e obrigações fiscais;",
      "interesse legítimo (art. 6.º, n.º 1, al. f): segurança da plataforma e prevenção de fraude;",
      "consentimento (art. 6.º, n.º 1, al. a): comunicações comerciais, quando aplicável.",
    ],
  },
  {
    title: "5. Partilha de Dados com Terceiros",
    paras: ["Os dados pessoais poderão ser partilhados, na medida do estritamente necessário, com:"],
    list: [
      "parceiros e fornecedores das atrações, exclusivamente para validação do PASS e prestação da experiência (nome do titular e estado do passaporte);",
      "Stripe (processamento de pagamentos e Stripe Connect);",
      "prestadores de serviços tecnológicos que suportam a plataforma (alojamento, envio de emails transacionais e armazenamento de imagens);",
      "autoridades públicas, quando legalmente exigido.",
    ],
    parasAfter: [
      "O PASS Algarve não vende dados pessoais a terceiros.",
      "Alguns prestadores de serviços poderão estar localizados fora do Espaço Económico Europeu. Nesses casos, o PASS Algarve assegura que as transferências são realizadas com garantias adequadas, nomeadamente cláusulas contratuais-tipo aprovadas pela Comissão Europeia.",
    ],
  },
  {
    title: "6. Prazos de Conservação",
    paras: [
      "Os dados pessoais são conservados apenas pelo período necessário às finalidades para que foram recolhidos:",
    ],
    list: [
      "dados de conta: enquanto a conta se mantiver ativa;",
      "dados de compras e faturação: pelos prazos legais aplicáveis (regra geral, 10 anos para efeitos fiscais);",
      "dados de validação do PASS: durante o período de validade do passaporte e pelos prazos necessários à gestão de eventuais reclamações;",
      "dados tratados com base no consentimento: até à retirada do mesmo.",
    ],
  },
  {
    title: "7. Direitos do Titular dos Dados",
    paras: ["Nos termos do RGPD, o utilizador tem direito a:"],
    list: [
      "aceder aos seus dados pessoais;",
      "solicitar a retificação de dados inexatos;",
      "solicitar o apagamento dos dados, quando aplicável;",
      "solicitar a limitação do tratamento;",
      "opor-se ao tratamento, nos casos previstos na lei;",
      "solicitar a portabilidade dos dados;",
      "retirar o consentimento a qualquer momento, sem comprometer a licitude do tratamento efetuado até essa data.",
    ],
    parasAfter: [
      "Para exercer os seus direitos, o utilizador deve contactar info@passalgarve.com. O PASS Algarve responderá no prazo máximo de um mês, prorrogável nos termos legais.",
      "O utilizador tem ainda o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD) — www.cnpd.pt.",
    ],
  },
  {
    title: "8. Segurança dos Dados",
    paras: [
      "O PASS Algarve adota medidas técnicas e organizativas adequadas para proteger os dados pessoais contra acessos não autorizados, perda, alteração ou divulgação indevida, incluindo comunicações cifradas (HTTPS), armazenamento cifrado de credenciais e controlo de acessos por perfil.",
      "Os pagamentos são processados pela Stripe, entidade certificada PCI-DSS, não passando os dados completos de cartão pelos servidores do PASS Algarve.",
    ],
  },
  {
    title: "9. Cookies e Tecnologias Semelhantes",
    paras: [
      "A plataforma utiliza cookies e tecnologias semelhantes estritamente necessárias ao seu funcionamento, nomeadamente para gestão de sessão e preferências de idioma.",
      "Quando sejam utilizados cookies não essenciais (por exemplo, para fins analíticos ou de marketing), estes apenas serão ativados mediante consentimento do utilizador.",
    ],
  },
  {
    title: "10. Menores",
    paras: [
      "A plataforma não se destina à criação de contas por menores de 16 anos. As compras devem ser efetuadas por adultos, que poderão indicar os nomes dos titulares dos passaportes, incluindo menores sob a sua responsabilidade.",
    ],
  },
  {
    title: "11. Alterações a esta Política",
    paras: [
      "O PASS Algarve poderá atualizar esta Política de Privacidade sempre que necessário. A versão atualizada será publicada na plataforma com indicação da data da última atualização.",
      "Recomendamos a consulta periódica desta página.",
    ],
  },
];

export const PRIVACY_EN = [
  {
    title: "1. Data Controller",
    paras: [
      "The PASS Algarve platform is operated by GORGEOUS BLOSSOM TOURISM LDA, registered under tax number (NIF/NIPC) 517 954 095, with registered office in Lagos, Algarve, Portugal (hereinafter \"PASS Algarve\").",
      "PASS Algarve is the controller of the personal data collected through the passalgarve.com website and associated services.",
      "For any question relating to the processing of personal data, users may contact us at info@passalgarve.com.",
    ],
  },
  {
    title: "2. Personal Data Collected",
    paras: ["In the context of using the platform, the following personal data may be collected:"],
    list: [
      "identification data: first and last name;",
      "contact data: email address;",
      "account data: access credentials (the password is stored in encrypted form);",
      "purchase data: passports purchased, quantity, holder names provided, purchase and usage history;",
      "payment data: processed directly by Stripe — PASS Algarve does not store card numbers;",
      "PASS usage data: QR Code validations, date, time and attraction visited;",
      "technical data: IP address, device type and browser, where necessary for the security and operation of the platform.",
    ],
  },
  {
    title: "3. Purposes of Processing",
    paras: ["Personal data is processed for the following purposes:"],
    list: [
      "creation and management of the customer account;",
      "processing of purchases and issuance of digital passports and QR Codes;",
      "sending communications necessary for the performance of the service (purchase confirmations, QR Codes, changes and cancellations);",
      "validation of passports at partner attractions;",
      "management of bookings, where applicable;",
      "customer support;",
      "prevention and detection of fraud and misuse;",
      "compliance with legal, tax and accounting obligations.",
    ],
  },
  {
    title: "4. Legal Bases",
    paras: ["Data processing is based on the following grounds provided for in the GDPR:"],
    list: [
      "performance of a contract (art. 6(1)(b)): account management, purchases, issuance and validation of passports;",
      "compliance with legal obligations (art. 6(1)(c)): invoicing and tax obligations;",
      "legitimate interest (art. 6(1)(f)): platform security and fraud prevention;",
      "consent (art. 6(1)(a)): commercial communications, where applicable.",
    ],
  },
  {
    title: "5. Data Sharing with Third Parties",
    paras: ["Personal data may be shared, to the extent strictly necessary, with:"],
    list: [
      "partners and suppliers of the attractions, exclusively for PASS validation and delivery of the experience (holder name and passport status);",
      "Stripe (payment processing and Stripe Connect);",
      "technology service providers that support the platform (hosting, transactional email sending and image storage);",
      "public authorities, where legally required.",
    ],
    parasAfter: [
      "PASS Algarve does not sell personal data to third parties.",
      "Some service providers may be located outside the European Economic Area. In such cases, PASS Algarve ensures that transfers are carried out with appropriate safeguards, namely standard contractual clauses approved by the European Commission.",
    ],
  },
  {
    title: "6. Retention Periods",
    paras: [
      "Personal data is kept only for the period necessary for the purposes for which it was collected:",
    ],
    list: [
      "account data: while the account remains active;",
      "purchase and invoicing data: for the applicable legal periods (as a general rule, 10 years for tax purposes);",
      "PASS validation data: during the passport's validity period and for the periods necessary to manage any complaints;",
      "data processed on the basis of consent: until consent is withdrawn.",
    ],
  },
  {
    title: "7. Data Subject Rights",
    paras: ["Under the GDPR, users have the right to:"],
    list: [
      "access their personal data;",
      "request the rectification of inaccurate data;",
      "request the erasure of data, where applicable;",
      "request the restriction of processing;",
      "object to processing, in the cases provided for by law;",
      "request data portability;",
      "withdraw consent at any time, without affecting the lawfulness of the processing carried out until that date.",
    ],
    parasAfter: [
      "To exercise their rights, users should contact info@passalgarve.com. PASS Algarve will respond within a maximum of one month, extendable under the law.",
      "Users also have the right to lodge a complaint with the Portuguese Data Protection Authority (CNPD) — www.cnpd.pt.",
    ],
  },
  {
    title: "8. Data Security",
    paras: [
      "PASS Algarve adopts appropriate technical and organisational measures to protect personal data against unauthorised access, loss, alteration or improper disclosure, including encrypted communications (HTTPS), encrypted credential storage and role-based access control.",
      "Payments are processed by Stripe, a PCI-DSS certified entity; full card details never pass through PASS Algarve's servers.",
    ],
  },
  {
    title: "9. Cookies and Similar Technologies",
    paras: [
      "The platform uses cookies and similar technologies strictly necessary for its operation, namely for session management and language preferences.",
      "Where non-essential cookies are used (for example, for analytics or marketing purposes), they will only be activated with the user's consent.",
    ],
  },
  {
    title: "10. Minors",
    paras: [
      "The platform is not intended for the creation of accounts by minors under 16 years of age. Purchases must be made by adults, who may indicate the names of the passport holders, including minors under their responsibility.",
    ],
  },
  {
    title: "11. Changes to this Policy",
    paras: [
      "PASS Algarve may update this Privacy Policy whenever necessary. The updated version will be published on the platform with an indication of the date of the last update.",
      "We recommend checking this page periodically.",
    ],
  },
];
